import React from 'react';
import Form from '../../components/contactUs/Form';
import Navbar from '../../components/navbar/Navbar';

function Support() {
  return (
    <>
    
    <Form/>
    </>
  )
}
export default Support;
